export default "__VITE_ASSET__b870c846__"